import axios from "axios";

export const getRoles = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ROLES_PENDING" });
    const response = await axios("/api/admin/v1/roles", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "GET_ROLES_FULFILLED", payload: response.data?.roles });
  } catch (error) {
    dispatch({ type: "GET_ROLES_FAILED", payload: error.response.data });
  }
};

export const getAdminUsers =
  (token, limit, page, search, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ADMINS_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/get-admin-users/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ADMINS_LIST_FULFILLED",
          payload: response.data.adminUsers,
          adminUserCount: response.data?.adminUserCount,
        });
      } catch (error) {
        dispatch({ type: "GET_ADMINS_LIST_FAILED", payload: error.response.data });
      }
    };

export const getCategories =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CATEGORIES_PENDING" });
        const response = await axios(
          `/api/admin/v1/categories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CATEGORIES_FULFILLED",
          payload: response.data.categories,
        });
      } catch (error) {
        dispatch({ type: "GET_CATEGORIES_FAILED", payload: error.response?.data });
      }
    };

export const getCategoriesList =
  (token, limit, page, search, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CATEGORIES_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/category-list?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CATEGORIES_LIST_FULFILLED",
          payload: response.data.categories,
          categoriesCount: response.data?.categoriesCount
        });
      } catch (error) {
        dispatch({ type: "GET_CATEGORIES_LIST_FAILED", payload: error.response.data });
      }
    };

export const getSubCategoriesList =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SUBCATEGORIES_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/subcategories-list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SUBCATEGORIES_LIST_FULFILLED",
          payload: response.data.subCategories,
        });
      } catch (error) {
        dispatch({
          type: "GET_SUBCATEGORIES_LIST_FAILED",
          payload: error.response.data,
        });
      }
    };

export const getSubCategories =
  (token, paginate, page, search = "", category = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SUBCATEGORIES_PENDING" });
        const response = await axios(
          `/api/admin/v1/subcategories/?limit=${paginate || 10}&page=${page || 0
          }&search=${search}&category=${category}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SUBCATEGORIES_FULFILLED",
          payload: response.data.subCategories,
          subCategoryCount: response.data?.subCategoriesCount,
        });
      } catch (error) {
        dispatch({
          type: "GET_SUBCATEGORIES_FAILED",
          payload: error.response.data,
        });
      }
    };

export const getSubSubCategories =
  (token, paginate, page, search = "", category = "", subcategory = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SUBSUBCATEGORIES_PENDING" });
        const response = await axios(
          `/api/admin/v1/subsubcategories/?limit=${paginate || 10}&page=${page || 0
          }&search=${search}&category=${category}&subcategory=${subcategory}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SUBSUBCATEGORIES_FULFILLED",
          payload: response.data.subSubCategories,
          subSubCategoryCount: response.data?.subSubCategoriesCount,
        });
      } catch (error) {
        dispatch({
          type: "GET_SUBSUBCATEGORIES_FAILED",
          payload: error.response.data,
        });
      }
    };

export const getOfferList =
  (token, limit, page, search, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_OFFERLIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/offer-list/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_OFFERLIST_FULFILLED",
          payload: response.data.OfferLists,
          offerCount: response.data?.offerCount,
        });
      } catch (error) {
        dispatch({
          type: "GET_OFFERLIST_FAILED",
          payload: error.response.data,
        });
      }
    };

export const getBannerList = (token, limit, page, search, sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_BANNERLIST_PENDING" })
      const response = await axios(
        `/api/admin/v1/banner-list/?limit=${limit || 10}&page=${page || 0
        }&search=${search}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_BANNERLIST_FULFILLED",
        payload: response.data.BannerLists,
        bannerCount: response.data?.bannerCount,
      });
    } catch (error) {
      dispatch({
        type: "GET_BANNERLIST_FAILED",
        payload: error.response.data,
      });
    }
  };


export const getOrganizationVideoList = (token, limit, page, search, sort) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ORGANIZATIONVIDEO_LIST_PENDING" })
      const response = await axios(
        `/api/admin/v1/organization-video-list/?limit=${limit || 10}&page=${page || 0
        }&search=${search}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_ORGANIZATIONVIDEO_LIST_FULFILLED",
        payload: response.data.organizationVideoLists,
        organizationVideoCount: response.data?.organizationVideoCount,
      });

    } catch (error) {
      dispatch({
        type: "GET_ORGANIZATIONVIDEO_LIST_FAILED",
        payload: error.response.data,
      });
    }

  };

export const getOrganizationList = (token, limit, page, search, sort) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ORGANIZATION_LIST_PENDING" })
      const response = await axios(
        `/api/admin/v1/organization-list/?limit=${limit || 10}&page=${page || 0
        }&search=${search}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_ORGANIZATION_LIST_FULFILLED",
        payload: response.data.organizationList,
        organizationCount: response.data?.organizationCount,
      });

    } catch (error) {
      dispatch({
        type: "GET_ORGANIZATION_LIST_FAILED",
        payload: error.response.data,
      });
    }

  };

export const getPlaceList = (token, limit, page, search = "", sort = "desc", category = "", subCategory = "", subSubCategory = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_PLACE_LIST_PENDING" })
      const response = await axios(
        `/api/admin/v1/place-list?limit=${limit || 10}&page=${page || 0
        }&search=${search}&sort=${sort}&category=${category}&subCategory=${subCategory}&subSubCategory=${subSubCategory}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PLACE_LIST_FULFILLED",
        payload: response.data.PlaceLists,
        placeCount: response.data?.placeCount,
      });

    } catch (error) {
      dispatch({
        type: "GET_PLACE_LIST_FAILED",
        payload: error.response.data,
      });
    }

  };

export const getPlaceListForPrice = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_PRICE_PLACE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/place-list-for-price`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_PRICE_PLACE_LIST_FULFILLED",
      payload: response.data.pricePlaceList,
    });

  } catch (error) {
    dispatch({
      type: "GET_PRICE_PLACE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getZoneList = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ZONE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-zone-list`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_ZONE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_ZONE_LIST_FAILED",
      payload: error.response.data,
    });
  }
};
export const getZoneListByPlace = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ZONE_LIST_BY_PLACE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-zone-list-by-place/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_ZONE_LIST_BY_PLACE_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_ZONE_LIST_BY_PLACE_FAILED",
      payload: error.response.data,
    });
  }
};
export const getAllZonesByPlace = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ALL_BY_PLACE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-all-zones-by-place/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_ALL_BY_PLACE_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_ALL_BY_PLACE_FAILED",
      payload: error.response.data,
    });
  }
};
export const getSubZoneListByZone = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_SUB_ZONE_LIST_BY_ZONE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-sub-zone-list-by-zone/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_SUB_ZONE_LIST_BY_ZONE_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_SUB_ZONE_LIST_BY_ZONE_FAILED",
      payload: error.response.data,
    });
  }
};
export const getSubSubZoneListBySubZone = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_SUB_SUB_ZONE_LIST_BY_ZONE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-sub-sub-zone-list-by-sub-zone/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({
      type: "GET_SUB_SUB_ZONE_LIST_BY_ZONE_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "GET_SUB_SUB_ZONE_LIST_BY_ZONE_FAILED",
      payload: error.response.data,
    });
  }
};
export const getAllTicketType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ALL_TICKET_TYPE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-all-ticket-type/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_ALL_TICKET_TYPE_FULFILLED",
      payload: response,
    });

  } catch (error) {
    dispatch({
      type: "GET_ALL_TICKET_TYPE_FAILED",
      payload: error.response.data,
    });
  }

};
export const getTicketType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_TYPE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-ticket-type/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TICKET_TYPE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TICKET_TYPE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getTicketSubType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_SUB_TYPE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-ticket-sub-type/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TICKET_SUB_TYPE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TICKET_SUB_TYPE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getTicketSubSubType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_SUB_SUB_TYPE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-ticket-sub-sub-type/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TICKET_SUB_SUB_TYPE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TICKET_SUB_SUB_TYPE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getTouristType = (token, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TOURIST_TYPE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-tourist-type-list-by-place/${placeId}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TOURIST_TYPE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TOURIST_TYPE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getTicketPriceList = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_PRICE_LIST_PENDING" })
    const response = await axios(
      `/api/admin/v1/ticket-price-list`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TICKET_PRICE_LIST_FULFILLED",
      payload: response.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TICKET_PRICE_LIST_FAILED",
      payload: error.response.data,
    });
  }

};
export const getStateList =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_STATE_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/state-list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_STATE_LIST_FULFILLED",
          payload: response.data.stateLists
        });
      } catch (error) {
        dispatch({ type: "GET_STATE_LIST_FAILED", payload: error.response.data });
      }
    };

export const getGalleryList =
  (token, limit, page, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_GALLERY_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/gallery-list/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_GALLERY_LIST_FULFILLED",
          payload: response.data.GalleryLists,
          galleryCount: response.data?.galleryCount,
        });
      } catch (error) {
        dispatch({ type: "GET_GALLERY_LIST_FAILED", payload: error.response.data });
      }
    };
export const getHomeList =
  (token, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_HOME_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/home-list/?sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_HOME_LIST_FULFILLED",
          payload: response.data.HomeLists,
          galleryCount: response.data?.HomeCount,
        });
      } catch (error) {
        dispatch({ type: "GET_HOME_LIST_FAILED", payload: error.response.data });
      }
    };
export const getAllPlaces =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ALL_PLACE_PENDING" });
        const response = await axios(
          `/api/admin/v1/get-all-places`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ALL_PLACE_FULFILLED",
          payload: response.data.data
        });
      } catch (error) {
        dispatch({ type: "GET_ALL_PLACE_FAILED", payload: error.response.data });
      }
    };

export const getMerchants =
  (token, limit, page, search = "", place = "", sort = "desc", approved = "") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MERCHANT_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/merchants/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&place=${place}&sort=${sort}&approved=${approved}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MERCHANT_LIST_FULFILLED",
          payload: response.data.MerchantLists,
          merchantCount: response.data?.merchantCount,
        });
      } catch (error) {
        dispatch({ type: "GET_MERCHANT_LIST_FAILED", payload: error.response.data });
      }
    };

export const getAllMerchants =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ALL_MERCHANTS_PENDING" });
        const response = await axios(
          `/api/admin/v1/all-merchants`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ALL_MERCHANTS_FULFILLED",
          payload: response.data.MerchantLists
        });
      } catch (error) {
        dispatch({ type: "GET_ALL_MERCHANTS_FAILED", payload: error.response.data });
      }
    };

export const getMerchantPortfolios =
  (token, limit, page, search, merchant, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MERCHANT_PORTFOLIO_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/merchantportfolio/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&merchant=${merchant}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MERCHANT_PORTFOLIO_LIST_FULFILLED",
          payload: response.data.MerchantPortfolioLists,
          merchantPortfolioCount: response.data?.merchantPortfolioCount,
        });
      } catch (error) {
        dispatch({ type: "GET_MERCHANT_PORTFOLIO_LIST_FAILED", payload: error.response.data });
      }
    };

export const getBlogCategory =
  (token, limit, page, search, sort, type) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_BLOG_CATEGORY_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/blog-category/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}&type=${type}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_BLOG_CATEGORY_LIST_FULFILLED",
          payload: response.data.BlogCategoryList,
          blogCategoryCount: response.data?.blogCategoryCount,
        });
      } catch (error) {
        dispatch({ type: "GET_BLOG_CATEGORY_LIST_FAILED", payload: error.response.data });
      }
    };

export const getAllBlogCategory =
  (token, type) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ALL_BLOG_CATEGORY_PENDING" });
        const response = await axios(
          `/api/admin/v1/all-blog-category/?type=${type}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ALL_BLOG_CATEGORY_FULFILLED",
          payload: response.data.BlogCategories,
        });
      } catch (error) {
        dispatch({ type: "GET_ALL_BLOG_CATEGORY_FAILED", payload: error.response.data });
      }
    };

export const getBlog =
  (token, limit, page, search, category, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_BLOG_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/blogs/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&category=${category}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_BLOG_LIST_FULFILLED",
          payload: response.data.BlogList,
          blogCount: response.data?.blogCount,
        });
      } catch (error) {
        dispatch({ type: "GET_BLOG_LIST_FAILED", payload: error.response.data });
      }
    };

export const getPartner =
  (token, limit, page, search, sort, verified, filterParams = {}) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_PARTNER_LIST_PENDING" });
        // console.log('GET_PARTNER_LIST_PENDING->limit', limit);
        const {
          category = "",
          state_id = "",
          time_filter = "",
          date_from = "",
          date_to = "",
        } = filterParams || {};
        let url = `/api/admin/v1/partners/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}&verified=${verified}`;
        if (category) url += `&category=${encodeURIComponent(category)}`;
        if (state_id) url += `&state_id=${encodeURIComponent(state_id)}`;
        if (time_filter) url += `&time_filter=${encodeURIComponent(time_filter)}`;
        if (date_from) url += `&date_from=${encodeURIComponent(date_from)}`;
        if (date_to) url += `&date_to=${encodeURIComponent(date_to)}`;
        const response = await axios(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        dispatch({
          type: "GET_PARTNER_LIST_FULFILLED",
          payload: response.data.PartnerLists,
          partnerCount: response.data?.partnerCount,
          statusCounts: response.data?.statusCounts,

        });
      } catch (error) {
        dispatch({ type: "GET_PARTNER_LIST_FAILED", payload: error.response.data });
      }
    };

export const getGovernmentPartner =
  (token, limit, page, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_PARTNER_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/government-partners/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_GOVERNMENT_PARTNER_LIST_FULFILLED",
          payload: response.data.PartnerLists,
          partnerCount: response.data?.partnerCount,
        });
      } catch (error) {
        dispatch({ type: "GET_GOVERNMENT_PARTNER_LIST_FAILED", payload: error.response.data });
      }
    };


export const getCheckThisOut =
  (token, limit, page, search, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CHECKTHISOUT_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/check-this-out/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CHECKTHISOUT_LIST_FULFILLED",
          payload: response.data.CheckThisOutLists,
          checkThisOutCount: response.data?.checkThisOutCount,
        });
      } catch (error) {
        dispatch({ type: "GET_CHECKTHISOUT_LIST_FAILED", payload: error.response.data });
      }
    };
export const getEvent =
  (token, limit, page, search, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_EVENT_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/events/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_EVENT_LIST_FULFILLED",
          payload: response.data.EventLists,
          eventCount: response.data?.eventCount,
        });
      } catch (error) {
        dispatch({ type: "GET_EVENT_LIST_FAILED", payload: error.response.data });
      }
    };

export const getScheme =
  (token, limit, page, search, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SCHEME_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/schemes/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SCHEME_LIST_FULFILLED",
          payload: response.data.SchemeLists,
          schemeCount: response.data?.schemeCount,
        });
      } catch (error) {
        dispatch({ type: "GET_SCHEME_LIST_FAILED", payload: error.response.data });
      }
    };

export const getSubscriber =
  (token, limit, page, search, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SUBSCRIBER_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/subscribers/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SUBSCRIBER_LIST_FULFILLED",
          payload: response.data.SubscriberLists,
          subscriberCount: response.data?.subscriberCount,
        });
      } catch (error) {
        dispatch({ type: "GET_SUBSCRIBER_LIST_FAILED", payload: error.response.data });
      }
    };

export const getReviewCategories = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_REVIEW_CATEGORY_LIST_PENDING" });
    const response = await axios("/api/admin/v1/review-category-list", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: "GET_REVIEW_CATEGORY_LIST_FULFILLED",
      payload: response.data.questionReviewCategories,
    });
  } catch (error) {
    dispatch({
      type: "GET_REVIEW_CATEGORY_LIST_FAILED",
      payload: error.response?.data,
    });
  }
};

export const getSeo =
  (token, limit, page, search, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SEO_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/seo-list/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SEO_LIST_FULFILLED",
          payload: response.data.SeoLists,
          SeoCount: response.data?.SeoCount,
        });
      } catch (error) {
        dispatch({ type: "GET_SEO_LIST_FAILED", payload: error.response.data });
      }
    };

export const getState =
  (token, limit, page, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_STATELIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/state-lists/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_STATELIST_FULFILLED",
          payload: response.data.StateLists,
          StateCount: response.data?.StateCount,
        });
      } catch (error) {
        dispatch({ type: "GET_STATELIST_FAILED", payload: error.response.data });
      }
    };

export const getBookingList =
  (token, limit, page, sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_BOOKING_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/booking-list/?limit=${limit || 10}&page=${page || 0
          }&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_BOOKING_LIST_FULFILLED",
          payload: response.data.BookingLists,
          bookingCount: response.data?.bookingCount,
        });
      } catch (error) {
        dispatch({ type: "GET_BOOKING_LIST_FAILED", payload: error.response.data });
      }
    };

export const getLocation =
  (token, paginate, page, search = "", category = "", subcategory = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SUBSUBCATEGORIES_PENDING" });
        const response = await axios(
          `/api/admin/v1/location/?limit=${paginate || 10}&page=${page || 0
          }&search=${search}&category=${category}&subcategory=${subcategory}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_LOCATIONS_FULFILLED",
          payload: response.data.locations,
          subSubCategoryCountCount: response.data?.locationsCount,
        });
      } catch (error) {
        dispatch({
          type: "GET_LOCATIONS_FAILED",
          payload: error.response.data,
        });
      }
    };

export const getDestination = (token, paginate, page, search = "", state_id = "", city_id = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DESTINATION_PENDING" });
      const response = await axios(
        `/api/admin/v1/destination/?limit=${paginate || 10}&page=${page || 0
        }&search=${search}&state_id=${state_id}&city_id=${city_id}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DESTINATION_FULFILLED",
        payload: response.data.stateCounts,
        destinationCount: response.data?.destinationCount,
      });
    } catch (error) {
      dispatch({
        type: "GET_DESTINATION_FAILED",
        payload: error.response.data,
      });
    }
  };

export const getcity =
  (token, paginate, page, search = "", category = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CITY_PENDING" });
        const response = await axios(
          `/api/admin/v1/city/?limit=${paginate || 10}&page=${page || 0
          }&search=${search}&category=${category}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CITY_FULFILLED",
          payload: response.data.cities,
          subCategoryCount: response.data?.citiesCount,
        });
      } catch (error) {
        dispatch({
          type: "GET_CITY_FAILED",
          payload: error.response.data,
        });
      }
    };




export const getOnlineBooking =
  (token, limit, page, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ONLINEbOOKING_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/online-booking/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ONLINEbOOKING_LIST_FULFILLED",
          payload: response.data.OnlineBookingists,
          OnlineBookingistCount: response.data?.OnlineBookingistCount,
        });
      } catch (error) {
        dispatch({ type: "GET_ONLINEbOOKING_LIST_FAILED", payload: error.response.data });
      }
    };


export const getTourCategory =
  (token, limit, page, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_TOURCATEGORY_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/tour-category/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&sort=${sort}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_TOURCATEGORY_LIST_FULFILLED",
          payload: response.data.TourCategorys,
          TourCategoryCount: response.data?.TourCategoryCount,
        });
      } catch (error) {
        dispatch({ type: "GET_TOURCATEGORY_LIST_FAILED", payload: error.response.data });
      }
    };


export const getTourGuides =
  (token, limit, page, search, category, sort) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_TOUR_GUIDE_LIST_PENDING" });
        const response = await axios(
          `/api/admin/v1/tour-guide-list/?limit=${limit || 10}&page=${page || 0
          }&search=${search}&category=${category}&sort=${sort}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        dispatch({
          type: "GET_TOUR_GUIDE_LIST_FULFILLED",
          payload: response.data,
          tourGuideCount: response.data,
        });
      } catch (error) {
        dispatch({ type: "GET_TOUR_GUIDE_LIST_FAILED", payload: error.response.data });
      }
    };


export const getBookingFormData = (token, limit, place_id, page, search, sort) => async (dispatch) => {
  try {
    dispatch({ type: "GET_BOOKING_FORM_DATA_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-booking-form-data/?limit=${limit || 10}&place_id=${place_id}&page=${page || 0
      }&search=${search}&sort=${sort}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_BOOKING_FORM_DATA_FULFILLED",
      payload: response.data,
      // tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_BOOKING_FORM_DATA_FAILED", payload: error.response.data });
  }
};
export const getAdditionalFields = (token, place_id, field_type_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ADDITIONAL_FIELDS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-additional-fields?place_id=${place_id}&field_type_id=${field_type_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_ADDITIONAL_FIELDS_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_ADDITIONAL_FIELDS_FAILED", payload: error.response.data });
  }
};
export const getSubAdditionalFields = (token, place_id, additional_field_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_SUB_ADDITIONAL_FIELDS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-sub-additional-fields?place_id=${place_id}&additional_field_id=${additional_field_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_SUB_ADDITIONAL_FIELDS_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_SUB_ADDITIONAL_FIELDS_FAILED", payload: error.response.data });
  }
};
export const getSubSubAdditionalFields = (token, place_id, sub_additional_field_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_SUB_SUB_ADDITIONAL_FIELDS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-sub-sub-additional-fields?place_id=${place_id}&sub_additional_field_id=${sub_additional_field_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_SUB_SUB_ADDITIONAL_FIELDS_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_SUB_SUB_ADDITIONAL_FIELDS_FAILED", payload: error.response.data });
  }
};
export const getVehicalCategoryList = (token, id = 0, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VEHICAL_CATEGORY_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-vehicle-category/${id}?place_id=${placeId}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({ type: "GET_VEHICAL_CATEGORY_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "GET_VEHICAL_CATEGORY_FAILED", payload: error.response.data });
  }
};

export const getVehicalTypeList = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VEHICAL_TYPE_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-vehicle-type-by-category/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({ type: "GET_VEHICAL_TYPE_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VEHICAL_TYPE_FAILED", payload: error.response.data });
  }
};
export const getAllCategoriesAndVehicals = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ALL_CATEGORIES_AND_VEHICAL_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-all-categories-vehicals/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({ type: "GET_ALL_CATEGORIES_AND_VEHICAL_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_ALL_CATEGORIES_AND_VEHICAL_FAILED", payload: error.response.data });
  }
};
export const getVehicalNumberList = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VEHICAL_NUMBER_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-vehicle-number-by-type/${id}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({ type: "GET_VEHICAL_NUMBER_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VEHICAL_NUMBER_FAILED", payload: error.response.data });
  }
};
export const getVisitorDetailsByPlace = (token, place_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_DETAILS_BY_PLACE_PENDING" });
    const response = await axios(`/api/admin/v1/get-visitor-details-by-place/${place_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    dispatch({
      type: "GET_VISITOR_DETAILS_BY_PLACE_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_DETAILS_BY_PLACE_FAILED", payload: error.response.data });
  }
};
export const getVisitorTypeByPlace = (token, place_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_TYPE_BY_PLACE_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-visitor-type-list-by-place/${place_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_VISITOR_TYPE_BY_PLACE_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_TYPE_BY_PLACE_FAILED", payload: error.response.data });
  }
};
export const getVisitorSubTypeByVisitorType = (token, place_id, field_type_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ADDITIONAL_FIELDS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-additional-fields?place_id=${place_id}&field_type_id=${field_type_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_ADDITIONAL_FIELDS_FULFILLED",
      payload: response.data,
      tourGuideCount: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_ADDITIONAL_FIELDS_FAILED", payload: error.response.data });
  }
};

export const getVisitorSubTypeByType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_SUB_TYPE_BY_TYPE_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-sub-visitor-type/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_VISITOR_SUB_TYPE_BY_TYPE_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_SUB_TYPE_BY_TYPE_FAILED", payload: error.response.data });
  }
};
export const getVisitorSubSubTypeBySubType = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-sub-sub-visitor-type/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_SUB_SUB_TYPE_BY_TYPE_FAILED", payload: error.response.data });
  }
};
export const getAllVisitorCategories = (placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ALL_VISITOR_CATEGORIES_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-all-visitor-categories/${placeId}`,
    );
    dispatch({ type: "GET_ALL_VISITOR_CATEGORIES_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_ALL_VISITOR_CATEGORIES_FAILED", payload: error.response.data });
  }
};

export const getVisitorDetailsByPlaceId = (placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_DETAILS_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-visitor-details-byPlaceId/${placeId}`,
    );
    dispatch({ type: "GET_VISITOR_DETAILS_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_DETAILS_FAILED", payload: error.response.data });
  }
};
export const getVisitorsCategories = () => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_CATEGORY_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-visitor-categories`,
    );
    dispatch({ type: "GET_VISITOR_CATEGORY_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_CATEGORY_FAILED", payload: error.response.data });
  }
};
export const getVisitorsSubCategories = (categorID) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_SUB_CATEGORY_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-visitor-sub-categories/${categorID}`,
    );
    dispatch({ type: "GET_VISITOR_SUB_CATEGORY_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_SUB_CATEGORY_FAILED", payload: error.response.data });
  }
};
export const getVisitorsSubSubCategories = (categorID, subCategoryID) => async (dispatch) => {
  try {
    dispatch({ type: "GET_VISITOR_SUB_SUB_CATEGORY_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-visitor-sub-sub-categories/${categorID}/${subCategoryID}`,
    );
    dispatch({ type: "GET_VISITOR_SUB_SUB_CATEGORY_FULFILLED", payload: response.data, });
  } catch (error) {
    dispatch({ type: "GET_VISITOR_SUB_SUB_CATEGORY_FAILED", payload: error.response.data });
  }
};

export const getBookingCategories = (token, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_BOOKING_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-groupBooking-categories/${placeId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_BOOKING_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_BOOKING_CATEGORIES_FAILED", payload: error.response.data });
  }
};
export const getBookingSubCategories = (token, placeId, categoryId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_BOOKING_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-groupBooking-subCategories/${placeId}/${categoryId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_BOOKING_SUB_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_BOOKING_CATEGORIES_FAILED", payload: error.response.data });
  }
};
export const getBookingSubSubCategories = (token, placeId, categoryId, subCategoryId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_BOOKING_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-groupBooking-subSubCategories/${placeId}/${categoryId}/${subCategoryId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_BOOKING_SUB_SUB_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_BOOKING_CATEGORIES_FAILED", payload: error.response.data });
  }
};

export const getBookingTimingFormData = (token, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_BOOKING_TIMING_FORM_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-booking-timing-formData/${placeId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_BOOKING_TIMING_FORM_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_BOOKING_TIMING_FORM_FAILED", payload: error.response.data });
  }
};

export const getTicketInfoByPlaceId = (token, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_INFO_PENDING" })
    const response = await axios(
      `/api/admin/v1/get-ticket-info-by-place/${placeId}`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );

    dispatch({
      type: "GET_TICKET_INFO_FULFILLED",
      payload: response?.data,
    });

  } catch (error) {
    dispatch({
      type: "GET_TICKET_INFO_FAILED",
      payload: error.response.data,
    });
  }

};
export const GetTermsAndConditions = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TERMS_AND_CONDITIONS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-terms-and-conditions`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({
      type: "GET_TERMS_AND_CONDITIONS_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_TERMS_AND_CONDITIONS_FAILED", payload: error.response.data });
  }
}
export const getRefuncdPolicy = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_REFUND_POLICY_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-refund-policy`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({
      type: "GET_REFUND_POLICY_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_REFUND_POLICY_FAILED", payload: error.response.data });
  }
}
export const getCancellationPolicy = (token) => async (dispatch) => {
  try {
    dispatch({ type: "GET_CANCELLATION_POLICY_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-cancellation-policy`,
      { headers: { Authorization: `Bearer ${token}`, }, }
    );
    dispatch({
      type: "GET_CANCELLATION_POLICY_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_CANCELLATION_POLICY_FAILED", payload: error.response.data });
  }
}

export const getAdditionalCategories = (token, placeId, type) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-additional-categories/${placeId}/${type}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_ADDITIONAL_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_FAILED", payload: error.response.data });
  }
};
export const getAdditionalSubCategories = (token, placeId, categoryId, type) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-additional-subCategories/${placeId}/${categoryId}/${type}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_ADDITIONAL_SUB_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_FAILED", payload: error.response.data });
  }
};
export const getAdditionalSubSubCategories = (token, placeId, categoryId, subCategoryId, type) => async (dispatch) => {
  try {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-additional-subSubCategories/${placeId}/${categoryId}/${subCategoryId}/${type}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_ADDITIONAL_SUB_SUB_CATEGORIES_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_ADDITIONAL_CATEGORIES_FAILED", payload: error.response.data });
  }
};
export const deleteTimings = (token, deleteIds, placeId) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_MULTIPLE_TIMING_PENDING" });
    const response = await axios.delete(
      `/api/admin/v1/delete-multiple-timings`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          deleteIds,
          placeId,
        },
      }
    );
    dispatch({
      type: "DELETE_MULTIPLE_TIMING_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "DELETE_MULTIPLE_TIMING_FAILED",
      payload: error.response?.data || error.message,
    });
  }
};

export const getTicketPriceDetails = (token, place_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKET_PRICE_DETAILS_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-ticket-price-details/${place_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_TICKET_PRICE_DETAILS_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_TICKET_PRICE_DETAILS_FAILED", payload: error.response.data });
  }
};

export const getTicketsPerDay = (token, place_id) => async (dispatch) => {
  try {
    dispatch({ type: "GET_TICKETS_PER_DAY_PENDING" });
    const response = await axios(
      `/api/admin/v1/get-tickets-per-day/${place_id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({
      type: "GET_TICKETS_PER_DAY_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: "GET_TICKETS_PER_DAY_FAILED", payload: error.response.data });
  }
};
